<section class="team-member" itemscope itemtype="https://schema.org/Person">
  <div class="team-member__round-image">
    <img itemprop="image" [src]="image" [alt]="name" loading="lazy">
  </div>
  <div class="team-member__details">
    <section class="team-member__details__text">
      <h3 itemprop="name"  class="team-member__details__text__name">{{ name }}</h3>
      <p itemprop="jobTitle" class="team-member__details__text__position" style="marginBottom:'16px'">{{ position }}</p>
      <p>
      <a class="team-member__details__text__phone" href="tel: {{ phone }}">{{ phone }}</a>
        <meta itemprop="telephone" content="{{phone}}"/>
      </p>
      <p>
      <a class="team-member__details__text__email" href="mailto: {{ email }}">{{ email }}</a>
        <meta itemprop="email" content="{{email}}"/>
      </p>
    </section>
  </div>
</section>
